import { render } from "./TagsModalActivitiesEducation.vue?vue&type=template&id=a67b8b42&scoped=true"
import script from "./TagsModalActivitiesEducation.vue?vue&type=script&lang=js"
export * from "./TagsModalActivitiesEducation.vue?vue&type=script&lang=js"

import "./TagsModalActivitiesEducation.vue?vue&type=style&index=0&id=a67b8b42&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a67b8b42"]])

export default __exports__